// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_sv-5";
export var filledCircle = "_sv-4";
export var historyEntry = "_sv-3";
export var messageSideLeft = "_sv-1";
export var messageSideRight = "_sv-2";
export var orderTrackingCarouselWrapper = "_sv-6";
export var orderTrackingInfoContainer = "_sv-0";